import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { db } from "../services/firebaseConfig";
import Footer from "../components/Layout/Footer";
import bcrypt from "bcryptjs";

import "../styles/Login.css";

const Login = ({ onLoginSuccess }) => {
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false); // ✅ Prevent multiple submits
    const navigate = useNavigate(); // ✅ Redirect user after login

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            navigate("/dashboard");
        }
    }, [navigate]);


    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const usersCollection = collection(db, "inventori", "selangor", "users");
            const userQuery = query(usersCollection, where("phone", "==", phone));
            const snapshot = await getDocs(userQuery);

            if (snapshot.empty) {
                setError("❌ Nombor telefon tidak berdaftar.");
                setLoading(false);
                return;
            }

            const userDoc = snapshot.docs[0];
            const userData = userDoc.data();

            let isMatch = false;

            // 🔎 semak sama ada password disimpan sebagai hash (bcrypt biasanya bermula dengan "$2")
            const isHashed = typeof userData.password === "string" && userData.password.startsWith("$2");

            if (isHashed) {
                // guna bcrypt.compare untuk user baru
                isMatch = await bcrypt.compare(password, userData.password);
            } else {
                // fallback: check plain text untuk user lama
                isMatch = (password === userData.password);

                // jika match, auto-upgrade → hash dan simpan balik
                if (isMatch) {
                    const hashedPassword = await bcrypt.hash(password, 10);
                    await updateDoc(doc(db, "inventori", "selangor", "users", userDoc.id), {
                        password: hashedPassword,
                    });
                    console.log(`🔒 Password user ${userDoc.id} telah di-upgrade ke bcrypt`);
                }
            }

            if (!isMatch) {
                setError("❌ Kata laluan tidak sah.");
                setLoading(false);
                return;
            }

            const loggedInUser = { id: userDoc.id, ...userData };

            // ✅ Store in localStorage for persistence
            localStorage.setItem("user", JSON.stringify(loggedInUser));
            localStorage.setItem("userId", userDoc.id);

            if (onLoginSuccess) onLoginSuccess(loggedInUser);

            // ✅ Redirect to Dashboard after login
            navigate("/dashboard");

        } catch (err) {
            console.error("Login failed:", err.message);
            setError("❌ Gagal log masuk. Sila cuba lagi.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="app-container">
            <div className="login-container">
                <img
                    src={require("../assets/logo_pasti.png")}
                    alt="Logo Pasti"
                    className="login-logo"
                />

                <h3 className="login-title">Inventori</h3>
                <p className="login-desc">PASTI Selangor</p>
                <p className="login-ver">v 1.0.15</p>


                <form onSubmit={handleLogin} className="login-form">
                    <input
                        type="tel"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                        className="login-input"
                        placeholder="No Telefon"
                        disabled={loading} // ✅ Disable input when loading
                    />

                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="login-input"
                        placeholder="Kata Laluan"
                        disabled={loading} // ✅ Disable input when loading
                    />

                    {error && <p className="error-message">{error}</p>}

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? "Logging in..." : "Masuk"}
                    </button>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default Login;
